import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { ReplyButton } from "../../model/ReplyButton";

export type ReplyButtonDeleteModalProps = {
  replyButton?: ReplyButton;
  handle: (val: string) => void;
}

export const ReplyButtonDeleteModal = ({
  open,
  toggle,
  closeOnClickOutside,
  replyButton,
  handle,
}: ModalProp & ReplyButtonDeleteModalProps) => {
  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
          {(replyButton !== undefined) ? (
          <>
            <div className="px-2 pb-4 sm:p-4">
              <div className="text-center sm:mt-3">
                <Dialog.Title
                  as="h3"
                  className="text-left text-lg font-medium leading-6 text-gray-900"
                >
                  {replyButton.name}
                </Dialog.Title>
              </div>
              <div className="mt-5">
                本当に削除しますか？
              </div>
            </div>
            <ModalFoterBox>
              <Button
                className="mx-2 mt-1 w-[132px]"
                outline
                onClick={toggle}
              >
                キャンセル
              </Button>
              <Button
                className="mt-1 mr-2 w-[132px]"
                color="red"
                onClick={() => handle(replyButton.id)}>削除</Button>
            </ModalFoterBox>
          </>
          ): (<></>)}
        </Dialog.Panel>
      </Modal>
    </>
  );
}
